<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-10">
          <h1 class="mt-5">Subscription Management</h1>
        </div>
        <div class="col-md-2"></div>
      </div>
      <mat-tab-group>
        <mat-tab *ngIf="!isLoading && !isUserManager && subscription.xmlaEndPoint == '' && !subscription.isApiSubscription"
                 label="Subscription">
          <div class="container" style="padding-top: 10px; min-height: 300px">
            <div class="row">
              <div class="col-md-2"></div>
              <div class="col-md-8">
                Only subscription admins can modify subscription settings.
              </div>
              <div class="col-md-2"></div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isLoading && isUserManager"
                 label="Manage Users">
          <div class="container" style="padding-top: 10px; min-height: 300px">
            <div class="row">
              <div class="col-md-10">
              </div>
              <div class="col-md-2">
                <button mat-raised-button
                        class="piButton"
                        (click)="addNewUser()">
                  Add New User
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b>License Usage: </b>
                <ng-container *ngIf="subscription.maxDesignerUsers > 0">
                  Designer ({{
                    subscription.maxDesignerUsers -
                      subscription.availableDesignerUsers
                  }}
                  of {{ subscription.maxDesignerUsers }})
                </ng-container>
                <ng-container>
                  &nbsp;&nbsp;|&nbsp;&nbsp;User Managers ({{
                    subscription.userManagerCount
                  }})
                </ng-container>
                <ng-container>
                  &nbsp;&nbsp;|&nbsp;&nbsp;Invoice Managers ({{
                    subscription.invoiceManagerCount
                  }})
                </ng-container>
                <ng-container *ngIf="subscription.maxDashboardUsers > 0">
                  &nbsp;&nbsp;|&nbsp;&nbsp;Dashboard ({{
                    subscription.maxDashboardUsers -
                      subscription.availableDashboardUsers
                  }}
                  of {{ subscription.maxDashboardUsers }})
                </ng-container>
                <ng-container *ngIf="subscription.maxReportUsers > 0">
                  &nbsp;&nbsp;|&nbsp;&nbsp;Report ({{
                    subscription.maxReportUsers -
                      subscription.availableReportUsers
                  }}
                  of {{ subscription.maxReportUsers }})
                </ng-container>
              </div>
            </div>
            <div class="row" style="padding-top: 15px">
              <div class="col-md-3 mainLabel">User Email Address</div>
              <div class="col-md-2 mainLabel">
                <center>License Slot</center>
              </div>
              <div class="col-md-2 mainLabel"><center>Registered</center></div>
              <div class="col-md-1 mainLabel">
                <center>User Manager</center>
              </div>
              <div class="col-md-1 mainLabel">
                <center>Invoice Manager</center>
              </div>
              <div class="col-md-2 mainLabel"><center>User Type</center></div>
              <div class="col-md-1 mainLabel"></div>
            </div>
            <ng-container *ngFor="let user of noRoleUsers; let idx = index">
              <div class="row table-row" style="padding-top: 5px">
                <div class="col-md-3">{{ user.emailAddress }}</div>
                <div class="col-md-2">
                  <center>{{ user.licenseIndex }}</center>
                </div>
                <div class="col-md-2">
                  <center>
                    <ng-container *ngIf="user.unregisteredUser">
                      <input type="checkbox" disabled />
                    </ng-container>
                    <ng-container *ngIf="!user.unregisteredUser">
                      <input type="checkbox" disabled checked="checked" />
                    </ng-container>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="norole-user-manager-{{ idx }}"
                                  [(ngModel)]="user.userManager"
                                  (change)="updateSingleUser(idx, 'NoRole')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="norole-invoice-manager-{{ idx }}"
                                  [(ngModel)]="user.invoiceManager"
                                  (change)="updateSingleUser(idx, 'NoRole')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-2">
                  <center>
                    <mat-select name="norole-user-type-{{ idx }}"
                                [(ngModel)]="user.userType"
                                (selectionChange)="updateSingleUser(idx, 'NoRole')">
                      <mat-option [value]="0">No Role</mat-option>
                      <mat-option *ngIf="subscription.maxReportUsers > 0"
                                  [value]="3">Report User</mat-option>
                      <mat-option *ngIf="subscription.maxDashboardUsers > 0"
                                  [value]="2">Dashboard User</mat-option>
                      <mat-option *ngIf="subscription.maxDesignerUsers > 0"
                                  [value]="1">Designer User</mat-option>
                    </mat-select>
                  </center>
                </div>
                <div class="col-md-1">
                  <a href="#" (click)="removeUser(user)">Delete</a>
                </div>
              </div>
            </ng-container>
            <ng-container *ngFor="let user of designerUsers; let idx = index">
              <div class="row table-row" style="padding-top: 5px">
                <div class="col-md-3">{{ user.emailAddress }}</div>
                <div class="col-md-2">
                  <center>{{ user.licenseIndex }}</center>
                </div>
                <div class="col-md-2">
                  <center>
                    <ng-container *ngIf="user.unregisteredUser">
                      <input type="checkbox" disabled />
                    </ng-container>
                    <ng-container *ngIf="!user.unregisteredUser">
                      <input type="checkbox" disabled checked="checked" />
                    </ng-container>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="designer-user-manager-{{ idx }}"
                                  [(ngModel)]="user.userManager"
                                  (change)="updateSingleUser(idx, 'Designer')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="designer-invoice-manager-{{ idx }}"
                                  [(ngModel)]="user.invoiceManager"
                                  (change)="updateSingleUser(idx, 'Designer')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-2">
                  <center>
                    <mat-select name="designer-user-type-{{ idx }}"
                                [(ngModel)]="user.userType"
                                (selectionChange)="updateSingleUser(idx, 'Designer')">
                      <mat-option [value]="0">No Role</mat-option>
                      <mat-option *ngIf="subscription.maxReportUsers > 0"
                                  [value]="3">Report User</mat-option>
                      <mat-option *ngIf="subscription.maxDashboardUsers > 0"
                                  [value]="2">Dashboard User</mat-option>
                      <mat-option *ngIf="subscription.maxDesignerUsers > 0"
                                  [value]="1">Designer User</mat-option>
                    </mat-select>
                  </center>
                </div>
                <div class="col-md-1">
                  <a href="#" (click)="removeUser(user)">Delete</a>
                  <ng-container *ngIf="user.unregisteredUser">
                    &nbsp;&nbsp;&nbsp;
                    <a href="#" (click)="resendInvitationEmail(user)">Re-Send Invite</a>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container *ngFor="let user of dashboardUsers; let idx = index">
              <div class="row table-row" style="padding-top: 5px">
                <div class="col-md-3">{{ user.emailAddress }}</div>
                <div class="col-md-2">
                  <center>{{ user.licenseIndex }}</center>
                </div>
                <div class="col-md-2">
                  <center>
                    <ng-container *ngIf="user.unregisteredUser">
                      <input type="checkbox" disabled />
                    </ng-container>
                    <ng-container *ngIf="!user.unregisteredUser">
                      <input type="checkbox" disabled checked="checked" />
                    </ng-container>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="dashboard-user-manager-{{ idx }}"
                                  [(ngModel)]="user.userManager"
                                  (change)="updateSingleUser(idx, 'Dashboard')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="dashboard-invoice-manager-{{ idx }}"
                                  [(ngModel)]="user.invoiceManager"
                                  (change)="updateSingleUser(idx, 'Dashboard')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-2">
                  <center>
                    <mat-select name="dashboard-user-type-{{ idx }}"
                                [(ngModel)]="user.userType"
                                (selectionChange)="updateSingleUser(idx, 'Dashboard')">
                      <mat-option [value]="0">No Role</mat-option>
                      <mat-option *ngIf="subscription.maxReportUsers > 0"
                                  [value]="3">Report User</mat-option>
                      <mat-option *ngIf="subscription.maxDashboardUsers > 0"
                                  [value]="2">Dashboard User</mat-option>
                      <mat-option *ngIf="subscription.maxDesignerUsers > 0"
                                  [value]="1">Designer User</mat-option>
                    </mat-select>
                  </center>
                </div>
                <div class="col-md-1">
                  <a href="#" (click)="removeUser(user)">Delete</a>
                </div>
              </div>
            </ng-container>
            <ng-container *ngFor="let user of reportUsers; let idx = index">
              <div class="row table-row" style="padding-top: 5px">
                <div class="col-md-3">{{ user.emailAddress }}</div>
                <div class="col-md-2">
                  <center>{{ user.licenseIndex }}</center>
                </div>
                <div class="col-md-2">
                  <center>
                    <ng-container *ngIf="user.unregisteredUser">
                      <input type="checkbox" disabled />
                    </ng-container>
                    <ng-container *ngIf="!user.unregisteredUser">
                      <input type="checkbox" disabled checked="checked" />
                    </ng-container>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="report-user-manager-{{ idx }}"
                                  [(ngModel)]="user.userManager"
                                  (change)="updateSingleUser(idx, 'Report')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-1">
                  <center>
                    <mat-checkbox name="report-invoice-manager-{{ idx }}"
                                  [(ngModel)]="user.invoiceManager"
                                  (change)="updateSingleUser(idx, 'Report')"></mat-checkbox>
                  </center>
                </div>
                <div class="col-md-2">
                  <center>
                    <mat-select name="report-user-type-{{ idx }}"
                                [(ngModel)]="user.userType"
                                (selectionChange)="updateSingleUser(idx, 'Report')">
                      <mat-option [value]="0">No Role</mat-option>
                      <mat-option *ngIf="subscription.maxReportUsers > 0"
                                  [value]="3">Report User</mat-option>
                      <mat-option *ngIf="subscription.maxDashboardUsers > 0"
                                  [value]="2">Dashboard User</mat-option>
                      <mat-option *ngIf="subscription.maxDesignerUsers > 0"
                                  [value]="1">Designer User</mat-option>
                    </mat-select>
                  </center>
                </div>
                <div class="col-md-1">
                  <a href="#" (click)="removeUser(user)">Delete</a>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isLoading && subGroups.length > 0 && isUserManager"
                 label="Manage Groups">
          <div class="container" style="padding-top: 10px; min-height: 300px">
            <div class="row">
              <div class="col-md-2">Select Group:</div>
              <div class="col-md-5">
                <mat-select name="group"
                            [(ngModel)]="selectedGroupId"
                            (selectionChange)="subscriptionGroupChanged()">
                  <mat-option [value]="-1">-- Select Group --</mat-option>
                  <mat-option *ngFor="let group of subGroups"
                              [value]="group.subscriptionGroupId">{{ group.groupName }}</mat-option>
                </mat-select>
              </div>
              <div class="col-md-5">
                <button mat-raised-button
                        class="piButton"
                        (click)="createGroup()">
                  Create New Group
                </button>&nbsp;&nbsp;&nbsp;
                <button mat-raised-button
                        class="piButton"
                        (click)="deleteGroup()">
                  Delete Selected Group
                </button>
              </div>
            </div>
            <mat-tab-group *ngIf="selectedGroup !== null">
              <mat-tab label="Group Users">
                <br />
                <span>
                  <b>Note:</b> Changes to use group memberships are
                  immediate.
                </span>
                <div class="container">
                  <div class="row">
                    <div class="col-md-1 mainLabel"></div>
                    <div class="col-md-11 mainLabel">Email</div>
                  </div>
                  <div class="row table-row" *ngFor="let user of selectedGroup.users">
                    <div class="col-md-1">
                      <center>
                        <input type="checkbox"
                               [(ngModel)]="user.isMember"
                               (change)="userStateChecked()" />
                      </center>
                    </div>
                    <div class="col-md-11">{{ user.emailAddress }}</div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Current Shares">
                <br />
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 mainLabel">Share Type</div>
                    <div class="col-md-6 mainLabel">Share Title</div>
                    <div class="col-md-3 mainLabel">Share Mode</div>
                  </div>
                  <div class="row table-row" *ngFor="let share of selectedGroup.shares">
                    <div class="col-md-3">{{ share.shareType }}</div>
                    <div class="col-md-6">{{ share.title }}</div>
                    <div class="col-md-3">{{ share.shareMode }}</div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isLoading && subscription.isApiSubscription" label="API Access">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-4">API Key</div>
              <div class="col-md-8">{{subscription.apiSubscriptionToken}}</div>
            </div>
            <div class="row">
              <div class="col-md-4">Data Set Rows:</div>
              <div class="col-md-8" *ngIf="subscription.apiDataSetRowUnlimited"><b>Unlimited</b></div>
              <div class="col-md-8" *ngIf="!subscription.apiDataSetRowUnlimited">
                {{subscription.apiDataSetRowsRemaining}} of {{subscription.apiDataSetRowAllowance}} Remaining For Month
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Source Data Rows:</div>
              <div class="col-md-8" *ngIf="subscription.apiSourceDataRowUnlimited"><b>Unlimited</b></div>
              <div class="col-md-8" *ngIf="!subscription.apiSourceDataRowUnlimited">
                {{subscription.apiSourceDataRowsRemaining}} of {{subscription.apiSourceDataRowAllowance}} Remaining For Month
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isLoading && subscription.xmlaEndPoint != ''"
                 label="Analytical Dataset Subscription">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-8">
                <strong>Contact your Public Insight representative to obtain your dataset access credentials.</strong>
              </div>
              <div class="col-md-4"></div>
            </div>
          </div>
        </mat-tab>
        <!--<mat-tab *ngIf="subscription.xmlaEndPoint == '' && subscription.apiSubscriptionToken != ''"
                 label="API Subscription">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-8">
                <b>API Authorization Token: </b> {{subscription.apiSubscriptionToken}}
              </div>
              <div class="col-md-4"></div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <b>Monthly Rows: </b> {{subscription.apiSubscriptionRowAllowance}}
              </div>
              <div class="col-md-4"></div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <b>Remaining Monthly Rows: </b> {{subscription.apiSubscriptionRowRemaining}}
              </div>
              <div class="col-md-4"></div>
            </div>
          </div>
        </mat-tab>-->
        <!--<mat-tab *ngIf="subscription.xmlaEndPoint == '' && isUserManager && !subscription.isApiSubscription"
                 label="Manage Settings">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-4">Enabled Domain Registration:</div>
              <div class="col-md-8">
                <mat-checkbox name="subscription.enableDomainUsers"
                              [(ngModel)]="subscription.enableDomainUsers"></mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Subscriber Domain:</div>
              <div class="col-md-8">
                <input matInput
                       type="text"
                       name="subscription.subscriberDomain"
                       [(ngModel)]="subscription.subscriberDomain" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <button mat-raised-button
                        class="piButton"
                        (click)="saveDomainChanges()">
                  Save Settings
                </button>
              </div>
              <div class="col-md-10"></div>
            </div>
          </div>
        </mat-tab>-->
        <mat-tab label="Pre Filters" *ngIf="!isLoading && subscription.allowPreFiltering">
          <pre-filter-editor [subscriptionId]="subscriptionId"></pre-filter-editor>
        </mat-tab>
        <mat-tab *ngIf="reportExports.length > 0" label="Report Exports">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-6">
                <button mat-raised-button
                        class="piButton"
                        (click)="loadReportExports()">
                  Reload Status
                </button>
              </div>
              <div class="col-md-6"></div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4 mainLabel">Interact / Report</div>
              <div class="col-md-3 mainLabel">Name</div>
              <div class="col-md-2 mainLabel">Started</div>
              <div class="col-md-2 mainLabel">Completed</div>
              <div class="col-md-1 mainLabel"></div>
            </div>
            <ng-container *ngFor="let export of reportExports">
              <div class="row table-row">
                <div class="col-md-4">
                  {{ export.interactName }} / {{ export.reportName }}
                </div>
                <div class="col-md-3">
                  {{ export.name }}
                  <ng-container *ngIf="export.status === 0">
                    - Running - {{ export.statusDescription }}
                  </ng-container>
                  <ng-container *ngIf="export.status === 2">
                    - Failed
                  </ng-container>
                </div>
                <div class="col-md-2">
                  {{ export.started | date: "short" }}
                </div>
                <div class="col-md-2">
                  <ng-container *ngIf="export.completed !== null">
                    {{ export.completed | date: "short" }}
                  </ng-container>
                </div>
                <div class="col-md-1">
                  <a href="#"
                     (click)="deleteExport(export)"
                     title="Delete Report">
                    <i class="fas fa-trash-alt"></i>
                  </a>
                  &nbsp;&nbsp;
                  <ng-container *ngIf="export.status == 1">
                    <a href="#"
                       (click)="downloadExport(export)"
                       title="Download Report">
                      <i class="fas fa-file-download"></i>
                    </a>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isLoading && isInvoiceManager" label="View Invoices">
          <div class="container" style="padding-top: 15px; min-height: 300px">
            <div class="row">
              <div class="col-md-3 mainLabel">Date</div>
              <div class="col-md-3 mainLabel">ID</div>
              <div class="col-md-3 mainLabel">Total</div>
              <div class="col-md-3 mainLabel">Invoice</div>
            </div>
            <ng-conatiner *ngFor="
                let invoice of subscription.invoiceManagementViewModel
                  .invoiceItems
              ">
              <div class="row table-row">
                <div class="col-md-3">
                  {{ invoice.invoiceDate | date: "mediumDate" }}
                </div>
                <div class="col-md-3">{{ invoice.invoiceID }}</div>
                <div class="col-md-3">{{ invoice.totalDue | currency }}</div>
                <div class="col-md-3">
                  <a href="{{ invoice.fileDownloadUrl }}">Download</a>
                </div>
              </div>
            </ng-conatiner>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
